/**
 * Indicates the type of media currently loading/loaded.
 */
export enum MediaType {
  Unknown = 'unknown',
  Audio = 'audio',
  Video = 'video',
  LiveVideo = 'live-video',
}
